import styled from "@emotion/styled";

import { fontMerriweather, fontRoboto, fontRobotoCondensed } from "shared/lib/styles";
import { theme } from "shared/lib/styles/theme";

import { EntityLink } from "scmp-app/components/entity-link";

export const StyledEntityLink = styled(EntityLink)``;

export const ArticleItem = styled.div`
  display: grid;
  grid:
    "headline flag" max-content
    "headline ." min-content
    / 1fr minmax(0, auto);

  inline-size: 100%;

  :not(:first-of-type) {
    margin-block-start: 5px;
    padding-block-start: 5px;
  }

  ${theme.breakpoints.up("tablet")} {
    grid:
      "headline flag publish-date" max-content
      "headline . . " min-content
      / 1fr minmax(0, auto) 82px;
  }
`;

export const PlusFlag = styled.div`
  grid-area: flag;

  margin-block: 4px;
  margin-inline-start: 8px;
  padding-inline: 2px;

  color: #ffffff;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;

  border-radius: 2px;

  background-color: #4585ff;
`;

export const PublishDate = styled.div`
  grid-area: publish-date;

  display: flex;
  align-items: center;

  max-block-size: 21px;
  margin-inline-start: 16px;
  padding-block: 4px;

  color: #727272;
  font-weight: 400;
  font-size: 11px;
  font-family: ${fontRoboto};

  ${theme.breakpoints.only("mobile")} {
    display: none;
  }

  ${theme.breakpoints.up("tablet")} {
    margin-block-start: 0;
  }
`;

export const Headline = styled.h4`
  grid-area: headline;

  ${StyledEntityLink} {
    color: #000000;
    font-weight: 600;
    font-size: 13px;
    font-family: ${fontMerriweather};
    font-style: normal;
    line-height: 130%;
  }
`;
